export default "__VITE_ASSET__Cw6$qgER__"